import Form from "./Form.vue";
import Modal from "./Modal.vue";

const ContactFormComponents = { Form, Modal };

export { 
    Form as ContactCreateOrUpdateForm,
    Modal as ContactCreateOrUpdateModal
};

export default ContactFormComponents;
